(() => {
  if (window.hmNewsletterSignupInitialized) return;
  window.hmNewsletterSignupInitialized = true;
  const pending = new WeakSet();

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const signup = form.closest('[data-hm-newsletter]');
    if (!signup) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending.has(form) || !form.reportValidity()) return;

    const email = form.querySelector('[name="contact[email]"]');
    const source = form.querySelector('[name="signup_source"]');
    const button = form.querySelector('[type="submit"]');
    const feedback = form.querySelector('[data-newsletter-feedback]');
    if (!email || !source || !button || !feedback) return;

    pending.add(form);
    const wasDisabled = button.disabled;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    feedback.hidden = true;
    const controller = new AbortController();
    let timedOut = false;
    let timer;

    try {
      const accountId = Number(signup.dataset.accountId);
      const popupId = Number(signup.dataset.popupId);
      const listId = signup.dataset.listId;
      if (!Number.isSafeInteger(accountId) || accountId <= 0 ||
          !Number.isSafeInteger(popupId) || popupId <= 0 || !/^[1-9]\d*$/.test(listId)) {
        throw new Error('Invalid newsletter configuration');
      }
      const contact = {
        email: email.value.trim(),
        signup_source: source.value,
        lists: { [listId]: true },
        popup_id: popupId
      };
      try {
        const cookie = document.cookie.split(';').map((part) => part.trim())
          .find((part) => part.startsWith('fls_id='));
        if (cookie) {
          const identity = decodeURIComponent(cookie.slice('fls_id='.length));
          if (identity) contact.flsid = identity;
        }
      } catch (_) {}

      const request = async () => {
        const response = await fetch('https://api.flashy.app/thunder/contact?overwrite=true&channel=false&primary_key=email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ account_id: accountId, contact }),
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Newsletter HTTP error');
        const result = await response.json();
        if (!result || result.success !== true) throw new Error('Newsletter rejected');
      };
      const timeout = new Promise((_, reject) => {
        timer = setTimeout(() => {
          timedOut = true;
          controller.abort();
          reject(new Error('Newsletter confirmation timeout'));
        }, 20000);
      });
      await Promise.race([request(), timeout]);
      form.reset();
      feedback.textContent = feedback.dataset.successMessage;
    } catch (_) {
      feedback.textContent = timedOut ? feedback.dataset.timeoutMessage : feedback.dataset.errorMessage;
    } finally {
      clearTimeout(timer);
      pending.delete(form);
      button.disabled = wasDisabled;
      form.removeAttribute('aria-busy');
      feedback.hidden = false;
      feedback.focus();
    }
  }, true);
})();
